import { render, staticRenderFns } from "./NotificationsSidebarSelectElement.vue?vue&type=template&id=2765f702&scoped=true&"
import script from "./NotificationsSidebarSelectElement.vue?vue&type=script&lang=js&"
export * from "./NotificationsSidebarSelectElement.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsSidebarSelectElement.vue?vue&type=style&index=0&id=2765f702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2765f702",
  null
  
)

export default component.exports